import type { Network, NetworkCaip } from '../types'
import { getChainId } from './getChainId'

export function getCaipFromNetwork(network: Network): NetworkCaip {
  return `eip155:${getChainId(network)}`
}
